<template>
  <div>
    <div class="listTable">
      <div class="margins">
        <span>
          <el-button
            @click="vectorPlot"
            class="base-button"
            size="mini"
            type="primary"
            icon="el-icon-plus"
            >确定</el-button
          >
        </span>
        <span> </span>
      </div>
      <YzTable
        @select="selectionRow"
        @select-all="handleSelectionChange"
        max-height="620px"
        :hasPage="false"
        :getData="checkAll"
        :afterRequest="afterRequest"
        :columnApi="columns"
        :listApi="listArray"
        :searchForm="searchForm"
        :autoLoad="true"
        ref="YzTable"
      />
    </div>
  </div>
</template>

<script>
let plotUti = undefined;
export default {
  data() {
    return {
      columns: "json/vectorPlot.json?v=2",
      listArray: "/mark/queryMyMarkList",
      searchForm: {
        page: 1,
        pageSize: 10,
        cardNumber: undefined,
      },
      selectAll: [],
    };
  },
  created() {},
  mounted() {
    plotUti = DBmap.plotUti;
  },
  beforeDestroy() {
    var tableRef = this.$refs["YzTable"].getInstance();
    const selectedAry = tableRef.selection;
    for (let i = 0; i < selectedAry.length; i++) {
      let row = selectedAry[i];
      plotUti.removeRow(row);
    }
  },
  methods: {
    //矢量标绘
    vectorPlot() {
      var tableRef = this.$refs["YzTable"].getInstance();
      const selectedAry = tableRef.selection;
      console.log(selectedAry);
      for (let i = 0; i < selectedAry.length; i++) {
        let row = selectedAry[i];
        let action = {};
        action.name = row.markName;
        action.type = "commonPlot";
        action.typeName = "我的标绘";
        action.delay = 1;
        action.data = row;
        this.$bus.$emit("addActionObj", action);
      }
      this.$parent.close();
    },
    selectionRow(selection, row) {
      let selected = selection.length && selection.indexOf(row) !== -1;
      plotUti.checkRow(row, selected);
    },
    handleSelectionChange(selection) {
      console.log(selection);
      if (selection.length > 0) {
        for (let i = 0; i < selection.length; i++) {
          let row = selection[i];
          plotUti.checkRow(row, true);
        }
      }
      if (selection.length < 1) {
        for (let i = 0; i < this.selectAll.length; i++) {
          let row = this.selectAll[i];
          plotUti.checkRow(row, false);
        }
      }
      this.selectAll = selection.slice();
    },
    afterRequest(res) {
      return {
        result: {
          items: res.result,
          total: 0,
        },
      };
    },

    checkAll() {
      this.$nextTick(() => {
        var table = this.$refs["YzTable"].getInstance();
        var data = this.$refs["YzTable"].getInnerData();
        for (let i = 0; i < data.length; i++) {
          let row = data[i];
          let uuid = row.markId;
          var entity = viewer.entities.getById(uuid);
          if (entity && entity.show) {
            table.toggleRowSelection(row, true);
          }
        }
      });
    },
    handleFilter() {
      this.searchForm.page = 1;
      this.$refs["YzTable"].getList(this.searchForm, true);
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
  },
};
</script>
